export enum BodySurveyConstants {
  SET_ASSESSMENT_SEQ = 'bodySurvey/SET_ASSESSMENT_SEQ',
  SET_EXAM_VALUE = 'bodySurvey/SET_EXAM_VALUE',
  SET_EXAM_PNNV_VALUE = 'bodySurvey/SET_EXAM_PNNV_VALUE',
  UPDATE_EXAM_VALUE = 'bodySurvey/UPDATE_EXAM_VALUE',
  UPDATE_EXAM_PNNV_VALUE = 'bodySurvey/UPDATE_EXAM_PNNV_VALUE',
  SET_FINDINGS_VALUE = 'bodySurvey/SET_FINDINGS_VALUE',
  SET_BODY_SURVEY = 'bodySurvey/SET_BODY_SURVEY',
  SET_DATE_TIME = 'bodySurvey/SETDATE_TIME',
  SAVE_BODY_SURVEY_ASSESSMENT = 'bodySurvey/SAVE_BODY_SURVEY_ASSESSMENT',
  SET_ZOOMED_BODY_PART = 'bodySurvey/SET_ZOOMED_BODY_PART',
  SET_SELECTED_BODY_PART = 'bodySurvey/SET_SELECTED_BODY_PART',
  SET_SELECTED_BODY_PARTS = 'bodySurvey/SET_SELECTED_BODY_PARTS',
  SET_ZOOMED_ENABLED_BODY_PARTS = 'bodySurvey/SET_ZOOMED_ENABLED_BODY_PARTS',
  SET_COMMENTS = 'bodySurvey/SET_COMMENTS',
  DELETE_BODY_SURVEY_EXAM = 'bodySurvey/DELETE_BODY_SURVEY_EXAM',
  SET_DOCUMENT_FINDING = 'bodySurvey/SET_DOCUMENT_FINDING',
  SET_BODY_PARTS_CONTAINER = 'bodySurvey/SET_BODY_PARTS_CONTAINER',
  DELETE_BODY_LOCATION_FINDING = 'bodySurvey/DELETE_BODY_LOCATION_FINDING',
  SET_CHEST_LUNG_MODE = 'bodySurvey/SET_CHEST_LUNG_MODE',
  SET_DEFAULTS = 'bodySurvey/SET_DEFAULTS',
  DELETE_SUMMARY_DATA = 'bodySurvey/DELETE_SUMMARY_DATA',
  SET_SEQUENCE = 'BodyAssessment/SET_SEQUENCE',
  OPERATION_TYPE_INCREMENT = 'BodyAssessment/OPERATION_TYPE_INCREMENT',
  OPERATION_TYPE_DECREMENT = 'BodyAssessment/OPERATION_TYPE_DECREMENT',
  SET_EXAMINATION_IN_PROGRESS = 'BodyAssessment/SET_EXAMINATION_IN_PROGRESS',
  SET_ENABLE_ZOOM = 'bodySurvey/SET_ENABLE_ZOOM',
  SET_ZOOM_VISIBLE = 'bodySurvey/SET_ZOOM_VISIBLE',
  SET_BOD = 'bodySurvey/SET_BOD',
  SET_BOD_VALUE = 'bodySurvey/SET_BOD_VALUE',
  RESET_BODY_SURVEY_VALUES = 'bodySurvey/RESET_BODY_SURVEY_VALUES',
  RESET_BODY_SURVEY_STATE = 'bodySurvey/RESET_BODY_SURVEY_STATE',
}
